import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Page } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  loading: { id: 'blob_eos_loading', defaultMessage: 'Loading' },
});

const SKELETON_GROUPS = [
  { id: 'group-a', targetWidths: ['70%', '55%'] as const },
  { id: 'group-b', targetWidths: ['65%', '45%', '60%'] as const },
] as const;

export const LoadingSkeleton: FC = () => {
  const intl = useIntl();

  return (
    <Page footerStyle="none">
      <S.Screen
        data-testid="blob-end-of-session-skeleton"
        aria-busy="true"
        aria-live="polite"
        aria-label={intl.formatMessage(msgs.loading)}
      >
        <S.HeaderSlot>
          <S.HeaderBar aria-hidden>
            <S.LogoBone />
            <S.HeaderActions>
              <S.HeaderPill />
              <S.HeaderPill />
              <S.HeaderPill />
            </S.HeaderActions>
          </S.HeaderBar>
        </S.HeaderSlot>
        <S.ScrollArea>
          <S.Content>
            <S.Hero>
              <S.ClipBone aria-hidden />
              <S.HeroText>
                <S.TitleBone aria-hidden />
                <S.SubheaderBone aria-hidden />
              </S.HeroText>
            </S.Hero>
            <S.Results>
              <S.Groups>
                {SKELETON_GROUPS.map(group => (
                  <S.GroupCard key={group.id} aria-hidden>
                    <S.GroupHeader>
                      <S.GroupTitleBone />
                      <S.GroupCountBone />
                    </S.GroupHeader>
                    <S.GroupList>
                      {group.targetWidths.map(width => (
                        <S.GroupRow key={`${group.id}-${width}`}>
                          <S.FlowerBone />
                          <S.WordLines>
                            <S.TargetBone $width={width} />
                            <S.SourceBone />
                          </S.WordLines>
                        </S.GroupRow>
                      ))}
                    </S.GroupList>
                  </S.GroupCard>
                ))}
              </S.Groups>
            </S.Results>
          </S.Content>
        </S.ScrollArea>
        <S.Footer>
          <S.ActionsContainer>
            <S.ButtonBone aria-hidden />
            <S.LinkBone aria-hidden />
          </S.ActionsContainer>
        </S.Footer>
      </S.Screen>
    </Page>
  );
};
